export default [{
        label: 'General Lights',
        value: 'LIGHT',
        icon: 'icon-a',
        icons: [{
                icon: "icon-a",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-b",
                tags: ["LIGHT", "GENERAL", "DARK"],
                position: {
                    row: 1,
                    column: 2
                }

            },
            {
                icon: "icon-c",
                tags: ["LIGHT", "PLUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-d2",
                tags: ["LIGHT", "MINUS", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-e2",
                tags: ["LIGHT", "GENERAL", "SUN", "ALL"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-03-17",
                tags: ["LIGHT", "GENERAL", "OFF", "SUN"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-03-18",
                tags: ["LIGHT", "GENERAL", "ON", "SUN"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-a3",
                tags: ["LIGHT", "GENERAL", "WALL", "SUN"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-b1",
                tags: ["LIGHT", "GENERAL", "SUN"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-c2",
                tags: ["LIGHT", "GENERAL", "STAIRCASE", "SUN"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-d1",
                tags: ["LIGHT", "WARDROBE", "SUN", "GENERAL"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-c1",
                tags: ["LIGHT", "GENERAL", "SUN", "KITCHEN"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-b2",
                tags: ["LIGHT", "GENERAL", "BED", "SUN"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-a2",
                tags: ["LIGHT", "GENERAL", "BATHROOM", "SUN"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-f",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-B-23-08",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-23-09",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 17
                }
            },
            {
                icon: "icon-B-23-10",
                tags: ["LIGHT", "LED", "GENERAL"],
                position: {
                    row: 1,
                    column: 18
                }
            },
            {
                icon: "icon-A-02-08",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 19
                }
            },
            {
                icon: "icon-A-02-09",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 20
                }
            },
            {
                icon: "icon-A-02-10",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 21
                }
            },
            {
                icon: "icon-A-02-11",
                tags: ["LIGHT", "LIGHTBULB", "GENERAL"],
                position: {
                    row: 1,
                    column: 22
                }
            },
            {
                icon: "icon-B-01-01",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-01-02",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-01-03",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-01-04",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-01-05",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-01-06",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-01-07",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-01-08",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-B-01-12",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 9
                }
            },
            {
                icon: "icon-B-03-19",
                tags: ["LIGHT", "PENDANT", "CHANDELIER"],
                position: {
                    row: 2,
                    column: 10,
                },
            },
            {
                icon: "icon-B-01-13",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-01-14",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-01-15",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-01-16",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-01-17",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-B-01-18",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 6
                }
            },
            {
                icon: "icon-B-01-20",
                tags: ["LIGHT", "LAMPS", "FLOOR LAMP"],
                position: {
                    row: 3,
                    column: 7
                }
            },
            {
                icon: "icon-B-01-09",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-B-01-10",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-d3",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-e3",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-B-01-11",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 5
                }
            },
            {
                icon: "icon-B-02-07",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 6
                }
            },
            {
                icon: "icon-B-02-06",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 7
                }
            },
            {
                icon: "icon-B-02-05",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 8
                }
            },
            {
                icon: "icon-B-02-02",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 9
                }
            },
            {
                icon: "icon-B-02-03",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 10
                }
            },
            {
                icon: "icon-B-02-04",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 11
                }
            },
            {
                icon: "icon-B-02-08",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 12
                }
            },
            {
                icon: "icon-B-02-09",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 13
                }
            },
            {
                icon: "icon-B-02-10",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 14
                }
            },
            {
                icon: "icon-B-30-01",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 15
                }
            },
            {
                icon: "icon-B-30-02",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 16
                }
            },
            {
                icon: "icon-B-30-03",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 17
                }
            },
            {
                icon: "icon-B-30-04",
                tags: ["LIGHT", "SPOT", "COVE"],
                position: {
                    row: 4,
                    column: 18
                }
            },
            {
                icon: "icon-g1",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-B-01-19",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-B-02-01",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 3
                }
            },
            {
                icon: "icon-e1",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 4
                }
            },
            {
                icon: "icon-f1",
                tags: ["LIGHT", "LAMPS", "TABLE LAMP"],
                position: {
                    row: 5,
                    column: 5
                }
            },
            {
                icon: "icon-B-02-12",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-B-02-13",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 2
                }
            },
            {
                icon: "icon-B-02-14",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 3
                }
            },
            {
                icon: "icon-B-02-15",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 4
                }
            },
            {
                icon: "icon-B-02-16",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 5
                }
            },
            {
                icon: "icon-B-02-17",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 6
                }
            },
            {
                icon: "icon-B-02-18",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 7
                }
            },
            {
                icon: "icon-B-02-19",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 8
                }
            },
            {
                icon: "icon-B-02-20",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 9
                }
            },
            {
                icon: "icon-B-03-01",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 10
                }
            },
            {
                icon: "icon-B-03-02",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 11
                }
            },
            {
                icon: "icon-B-03-03",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 12
                }
            },
            {
                icon: "icon-B-03-04",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 13
                }
            },
            {
                icon: "icon-B-03-05",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 14
                }
            },
            {
                icon: "icon-B-03-06",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 15
                }
            },
            {
                icon: "icon-B-03-07",
                tags: ["LIGHT", "WALL"],
                position: {
                    row: 6,
                    column: 16
                }
            },
            {
                icon: "icon-B-03-08",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 1
                }
            },
            {
                icon: "icon-B-03-09",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 2
                }
            },
            {
                icon: "icon-B-03-10",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 3
                }
            },
            {
                icon: "icon-B-03-11",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 4
                }
            },
            {
                icon: "icon-B-03-12",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 5
                }
            },
            {
                icon: "icon-B-03-13",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 6
                }
            },
            {
                icon: "icon-B-03-14",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 7
                }
            },
            {
                icon: "icon-B-03-15",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 8
                }
            },
            {
                icon: "icon-B-03-16",
                tags: ["LIGHT", "GENERAL"],
                position: {
                    row: 7,
                    column: 9
                }
            },
            {
                icon: "icon-d-icon1-light-dimming",
                tags: ["LIGHT", "GENERAL", "DIMMING", "SUN", "DARK", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 1
                }
            },
            {
                icon: "icon-d-icon2-dimming-plus",
                tags: ["LIGHT", "GENERAL", "DIMMING", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 2
                }
            },
            {
                icon: "icon-d-arrows1-light-standard",
                tags: ["LIGHT", "GENERAL", "ARROW", "SUN", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 3
                }
            },
            {
                icon: "icon-d-plus2-light-standard",
                tags: ["LIGHT", "GENERAL", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 4
                }
            },
            {
                icon: "icon-d-plus2-light-standard-2v",
                tags: ["LIGHT", "GENERAL", "PLUS", "MINUS", "SUN", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 5
                }
            },
            {
                icon: "icon-d-arrows2-light-lightbulb",
                tags: ["LIGHT", "GENERAL", "ARROW", "LIGHTBULB", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 6
                }
            },
            {
                icon: "icon-d-plus3-light-lightbulb",
                tags: ["LIGHT", "GENERAL", "LIGHTBULB", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 7
                }
            },
            {
                icon: "icon-d-plus3-light-lightbulb-2v",
                tags: ["LIGHT", "GENERAL", "LIGHTBULB", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 8,
                    column: 8
                }
            },
            {
                icon: "icon-h3",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 9,
                    column: 1
                }
            },
            {
                icon: "icon-h",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 9,
                    column: 2
                }
            },
            {
                icon: "icon-h1",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 9,
                    column: 3
                }
            },
            {
                icon: "icon-g2",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 9,
                    column: 4
                }
            },
            {
                icon: "icon-g3",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 9,
                    column: 5
                }
            },
            {
                icon: "icon-g4",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 9,
                    column: 6
                }
            },
            {
                icon: "icon-g5",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 9,
                    column: 7
                }
            },
            {
                icon: "icon-f6",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 9,
                    column: 8
                }
            },
            {
                icon: "icon-g7",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 9,
                    column: 9
                }
            },
        ]
    },
    {
        label: 'Hotel',
        value: 'HOTEL',
        icon: 'icon-B-22-02',
        icons: [{
                icon: "icon-a4",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-b4",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BELL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-c6",
                tags: ["HOTEL", "HOSPITALITY", "MUR", "ROOM"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-b5",
                tags: ["HOTEL", "HOSPITALITY", "STAFF", "ROOM"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-d6",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-22-15",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-22-16",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-22-17",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "DND"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-22-02",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-22-03",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-a5",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LUGGAGE"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-22-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "REGISTRATION"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-19-01",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "LIFT"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-19-02",
                tags: ["HOTEL", "HOSPITALITY", "PAY"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-23-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "WI-FI"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-c4",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-B-22-04",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "CONFERENCE"],
                position: {
                    row: 3,
                    column: 6
                }
            },
            {
                icon: "icon-e5",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-B-22-05",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-B-22-06",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-B-22-13",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-B-22-14",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 5
                }
            },
            {
                icon: "icon-B-22-08",
                tags: ["HOTEL", "HOSPITALITY", "DINING"],
                position: {
                    row: 4,
                    column: 6
                }
            },
            {
                icon: "icon-B-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-B-22-12",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-B-22-07",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 3
                }
            },
            {
                icon: "icon-B-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 5,
                    column: 4
                }
            },
            {
                icon: "icon-B-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 5,
                    column: 5
                }
            },
            {
                icon: "icon-B-22-09",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-B-22-10",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED"],
                position: {
                    row: 6,
                    column: 2
                }
            },
            {
                icon: "icon-B-22-18",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "BED", "SOFA"],
                position: {
                    row: 6,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Interface',
        value: 'INTERFACE',
        icon: 'icon-B-23-01',
        icons: [{
                icon: "icon-h3",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-g3",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-g2",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-g4",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-g5",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-f6",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-g7",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-A-11-16",
                tags: ["INTERFACE", "CANCEL", "CONTROL"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-A-11-17",
                tags: ["INTERFACE", "OK", "CONTROL"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-23-01",
                tags: ["INTERFACE", "SETTINGS", "CONTROL"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-23-02",
                tags: ["INTERFACE", "SETTINGS", "CONTROL"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-23-07",
                tags: ["INTERFACE", "CONTROL"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-h1",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-h",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-h2",
                tags: ["INTERFACE", "WORD", "AUTO", "CONTROL"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-A-10-04",
                tags: ["INTERFACE", "WORD", "MODE", "CONTROL"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-A-10-05",
                tags: ["INTERFACE", "WORD", "INPUT", "CONTROL"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-A-10-06",
                tags: ["INTERFACE", "WORD", "UP", "CONTROL"],
                position: {
                    row: 2,
                    column: 6
                }

            },
            {
                icon: "icon-A-10-07",
                tags: ["INTERFACE", "WORD", "DOWN", "CONTROL"],
                position: {
                    row: 2,
                    column: 7
                }

            },
            {
                icon: "icon-A-10-08",
                tags: ["INTERFACE", "WORD", "OPEN", "CONTROL"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-A-10-09",
                tags: ["INTERFACE", "WORD", "CLOSE", "CONTROL"],
                position: {
                    row: 2,
                    column: 9
                }
            },
            {
                icon: "icon-A-10-10",
                tags: ["INTERFACE", "WORD", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 10
                }
            },
            {
                icon: "icon-A-10-11",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 11
                }
            },
            {
                icon: "icon-A-10-12",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 2,
                    column: 12
                }
            },
            {
                icon: "icon-A-10-13",
                tags: ["INTERFACE", "WORD", "OK", "CONTROL"],
                position: {
                    row: 2,
                    column: 13
                }
            },
            {
                icon: "icon-B-23-03",
                tags: ["INTERFACE", "WORD", "SOS", "CONTROL"],
                position: {
                    row: 2,
                    column: 14
                }
            },
            {
                icon: "icon-B-23-04",
                tags: ["INTERFACE", "WORD", "NEW", "CONTROL"],
                position: {
                    row: 2,
                    column: 15
                }
            },
            {
                icon: "icon-B-23-05",
                tags: ["INTERFACE", "WORD", "SET", "CONTROL"],
                position: {
                    row: 2,
                    column: 16
                }
            },
            {
                icon: "icon-d-text1-on-off",
                tags: ["INTERFACE", "WORD", "ON", "OFF", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-d-text2-up-down",
                tags: ["INTERFACE", "WORD", "UP", "DOWN", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-d-text3-open-close",
                tags: ["INTERFACE", "WORD", "OPEN", "CLOSE", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-d-text4-cf-temp",
                tags: ["INTERFACE", "WORD", "HVAC", "CLIMA", "FAHRENHEITE", "CELSIUM", "TEMPERATURE", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-d-text5-cf-mode",
                tags: ["INTERFACE", "WORD", "HVAC", "CLIMA", "FAHRENHEIT", "CELSIUM", "TEMPERATURE", "MODE", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-d-arrows7-horizontal-open",
                tags: ["INTERFACE", "ARROW", "OPEN", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 6
                }
            },
            {
                icon: "icon-d-arrows8-vertical-open",
                tags: ["INTERFACE", "ARROW", "OPEN", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 7
                }
            },
            {
                icon: "icon-d-arrows9-up-down",
                tags: ["INTERFACE", "ARROW", "UP", "DOWN", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 8
                }
            },
            {
                icon: "icon-d-arrows10-sides",
                tags: ["INTERFACE", "ARROW", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 9
                }
            },
            {
                icon: "icon-d-plus1-simple",
                tags: ["INTERFACE", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 10
                }
            },
            {
                icon: "icon-d-plus1-simple-2v",
                tags: ["INTERFACE", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 11
                }
            },
        ]
    },
    {
        label: 'Scene',
        value: 'SCENE',
        icon: 'icon-f7',
        icons: [{
                icon: "icon-f2",
                tags: ["SCENE", "MOON", "DARK", "MOOD"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-g",
                tags: ["SCENE", "MORNING", "MOOD"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-e6",
                tags: ["SCENE", "MOOD", "RELAX", "DRINKS"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-f7",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 4
                }

            },
            {
                icon: "icon-B-15-13",
                tags: ["SCENE", "PILLOW", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-15-14",
                tags: ["SCENE", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-15-12",
                tags: ["SCENE", "HEART", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-15-18",
                tags: ["SCENE", "HEART", "MOOD", "RELAX"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-15-16",
                tags: ["SCENE", "MOOD", "PAINT", "DRAWING", "RELAX"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-B-24-01",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-24-02",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-24-05",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-d-icon8-morning-evening",
                tags: ["SCENE", "MOOON", "MORNING", "EVENING", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 3,
                    column: 1
                }
            },
        ]
    },
    {
        label: 'Sheers',
        value: 'BLIND',
        icon: 'icon-d',
        icons: [{
                icon: "icon-a1",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-b3",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-c3",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-B-07-11",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-07-06",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-07-04",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-07-10",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-07-09",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-07-07",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-07-01",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-07-05",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-e",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-f3",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 2
                }

            },
            {
                icon: "icon-d",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 3
                }

            },
            {
                icon: "icon-B-07-08",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-07-02",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-07-03",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-07-12",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-07-15",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-07-16",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-07-17",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-07-18",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "CURTAINS"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-d-icon5-curtains",
                tags: ["BLIND", "CURTAINS", "BLACKOUT", "SHEERS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-d-arrows4-curtains",
                tags: ["BLIND", "BLACKOUT", "SHEERS", "ARROW", "CURTAINS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-d-icon4-shutters",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-d-arrows5-shutters",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "ARROW", "SHEERS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-B-25-11",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-B-25-12",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-B-25-13",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 5,
                    column: 3
                }
            },
            {
                icon: "icon-B-25-14",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 5,
                    column: 4
                }
            },
            {
                icon: "icon-g2",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-g3",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 6,
                    column: 2
                }
            },
            {
                icon: "icon-g4",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 6,
                    column: 3
                }
            },
            {
                icon: "icon-g5",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 6,
                    column: 4
                }
            },
            {
                icon: "icon-f6",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 6,
                    column: 5
                }
            },
            {
                icon: "icon-g7",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 6,
                    column: 6
                }
            },
            {
                icon: "icon-A-03-07",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 7,
                    column: 1
                }
            },
            {
                icon: "icon-A-03-08",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 7,
                    column: 2
                }
            },
            {
                icon: "icon-A-03-09",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 7,
                    column: 3
                }
            },
            {
                icon: "icon-B-25-15",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 1
                }
            },
            {
                icon: "icon-B-25-16",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 2
                }
            },
            {
                icon: "icon-B-25-17",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 3
                }
            },
            {
                icon: "icon-B-25-18",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 4
                }
            },
            {
                icon: "icon-B-25-19",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 5
                }
            },
            {
                icon: "icon-B-25-20",
                tags: ["BLIND", "SHUTTERS", "BLACKOUT", "SHEERS"],
                position: {
                    row: 8,
                    column: 6
                }
            },
        ]
    },
    {
        label: 'Window/Door',
        value: 'DOOR',
        icon: 'icon-a6',
        icons: [{
                icon: "icon-B-08-01",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-08-02",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-08-03",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-08-04",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-08-05",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-08-06",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-08-07",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-08-08",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-08-09",
                tags: ["WINDOW"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-a6",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 1
                }

            },
            {
                icon: "icon-B-08-10",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-08-11",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-08-12",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-08-13",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-08-14",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-08-15",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-08-16",
                tags: ["DOOR"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-B-09-01",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-09-02",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-09-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-09-04",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-09-05",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 5
                }

            },
            {
                icon: "icon-B-09-06",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 6
                }

            },
            {
                icon: "icon-B-09-07",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 7
                }
            },
            {
                icon: "icon-B-09-11",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 8
                }
            },
            {
                icon: "icon-c4",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 3,
                    column: 9
                }
            },
            {
                icon: "icon-B-25-01",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-B-25-02",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-B-25-03",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-B-25-04",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-B-25-05",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 5
                }
            },
            {
                icon: "icon-B-25-06",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 6
                }
            },
            {
                icon: "icon-B-25-07",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 7
                }
            },
            {
                icon: "icon-B-25-08",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 8
                }
            },
            {
                icon: "icon-B-25-09",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 9
                }
            },
            {
                icon: "icon-B-25-10",
                tags: ["GATE"],
                position: {
                    row: 4,
                    column: 10
                }
            },
        ]
    },
    {
        label: 'HVAC',
        value: 'HVAC',
        icon: 'icon-a7',
        icons: [{
                icon: "icon-d4",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-e4",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 2
                }

            },
            {
                icon: "icon-f4",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-a7",
                tags: ["HVAC", "CLIMA", "CONTROL", "TEMPERATURE"],
                position: {
                    row: 1,
                    column: 4
                }


            },
            {
                icon: "icon-b6",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "COOLING"],
                position: {
                    row: 1,
                    column: 5
                }

            },
            {
                icon: "icon-c5",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "HEATING"],
                position: {
                    row: 1,
                    column: 6
                }

            },
            {
                icon: "icon-d5",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "ECO"],
                position: {
                    row: 1,
                    column: 7
                }

            },
            {
                icon: "icon-B-13-01",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-13-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-13-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-13-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-13-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-B-13-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "WEATHER"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-B-26-01",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-B-26-02",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-B-26-03",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-26-04",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 17
                }
            },
            {
                icon: "icon-B-26-05",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 18
                }
            },
            {
                icon: "icon-B-26-06",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN"],
                position: {
                    row: 1,
                    column: 19
                }
            },
            {
                icon: "icon-B-13-07",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-13-08",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-13-09",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-13-10",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 4
                }

            },
            {
                icon: "icon-B-13-11",
                tags: ["HVAC", "CLIMA", "CONTROL"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-19-16",
                tags: ["HVAC", "CLIMA", "HEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-19-17",
                tags: ["HVAC", "CLIMA", "COOLING", "CONTROL"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-19-18",
                tags: ["HVAC", "CLIMA", "FLOORHEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-B-19-19",
                tags: ["HVAC", "CLIMA", "FLOORHEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 9
                }
            },
            {
                icon: "icon-B-21-05",
                tags: ["HVAC", "CLIMA", "SIGNS", "COOLING", "CONTROL"],
                position: {
                    row: 2,
                    column: 10
                }
            },
            {
                icon: "icon-B-21-06",
                tags: ["HVAC", "CLIMA", "SIGNS", "HEATING", "CONTROL"],
                position: {
                    row: 2,
                    column: 11
                }
            },
            {
                icon: "icon-B-13-12",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-13-13",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-13-14",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 3
                }

            },
            {
                icon: "icon-B-13-15",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-13-16",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-B-13-17",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING"],
                position: {
                    row: 3,
                    column: 6
                }
            },
            {
                icon: "icon-B-26-07",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 7
                }
            },
            {
                icon: "icon-B-26-08",
                tags: ["HVAC", "CLIMA", "CONTROL", "AIR CONDITIONING", "FAN"],
                position: {
                    row: 3,
                    column: 8
                }
            },
            {
                icon: "icon-d-icon3-temperature-mode",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "TEMPERATURE", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-d-arrows3-temperature",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "ARROW", "TEMPERATURE", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-d-plus4-temperature",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "PLUS", "MINUS", "TEMPERATURE", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-d-plus4-temperature-2v",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "PLUS", "MINUS", "TEMPERATURE", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-d-plus6-fan",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 5
                }
            },
            {
                icon: "icon-d-plus6-fan-2v",
                tags: ["HVAC", "CLIMA", "CONTROL", "MODE", "FAN", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 6
                }
            },
            {
                icon: "icon-d-text4-cf-temp",
                tags: ["INTERFACE", "HVAC", "CLIMA", "WORD", "FAHRENGATE", "CELSIUM", "TEMPERATURE", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 7
                }
            },
            {
                icon: "icon-d-text5-cf-mode",
                tags: ["INTERFACE", "HVAC", "CLIMA", "WORD", "FAHRENGATE", "CELSIUM", "TEMPERATURE", "MODE", "CONTROL", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 4,
                    column: 8
                }
            },
            {
                icon: "icon-h3",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 5,
                    column: 1
                }

            },
            {
                icon: "icon-g2",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-g3",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 5,
                    column: 3
                }
            },
            {
                icon: "icon-g4",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 5,
                    column: 4
                }
            },
            {
                icon: "icon-g5",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 5,
                    column: 5
                }
            },
            {
                icon: "icon-f6",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 6
                }
            },
            {
                icon: "icon-g7",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 5,
                    column: 7
                }
            },
            {
                icon: "icon-h1",
                tags: ["INTERFACE", "WORD", "OFF", "CONTROL"],
                position: {
                    row: 5,
                    column: 8
                }

            },
            {
                icon: "icon-h",
                tags: ["INTERFACE", "WORD", "ON", "CONTROL"],
                position: {
                    row: 5,
                    column: 9
                }

            },
            {
                icon: "icon-h2",
                tags: ["INTERFACE", "WORD", "AUTO", "CONTROL"],
                position: {
                    row: 5,
                    column: 10
                }

            },
            {
                icon: "icon-A-10-04",
                tags: ["INTERFACE", "WORD", "MODE", "CONTROL"],
                position: {
                    row: 5,
                    column: 11
                }

            },
            {
                icon: "icon-A-10-10",
                tags: ["INTERFACE", "WORD", "CELSIUM", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 5,
                    column: 12
                }

            },
            {
                icon: "icon-A-10-11",
                tags: ["INTERFACE", "WORD", "FAHRENHEIT", "TEMPERATURE", "CONTROL"],
                position: {
                    row: 5,
                    column: 13
                }

            },
        ]
    },
    {
        label: 'Media',
        value: 'MEDIA',
        icon: 'icon-c7',
        icons: [{
                icon: "icon-f5",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-B-16-09",
                tags: ["MEDIA", "AV", "CINEMA", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-b7",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 3
                }

            },
            {
                icon: "icon-c7",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 4
                }

            },
            {
                icon: "icon-d7",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 5
                }

            },
            {
                icon: "icon-a8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 6
                }

            },
            {
                icon: "icon-b8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 7
                }

            },
            {
                icon: "icon-c8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 8
                }

            },
            {
                icon: "icon-d8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 9
                }

            },
            {
                icon: "icon-e8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 10
                }

            },
            {
                icon: "icon-f8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 11
                }

            },
            {
                icon: "icon-g8",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 12
                }

            },
            {
                icon: "icon-B-16-06",
                tags: ["MEDIA", "AV", "MUSIC", "VOLUME", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-e7",
                tags: ["MEDIA", "AV", "MUSIC", "KARAOKE", "AUDIO"],
                position: {
                    row: 1,
                    column: 14
                }

            },
            {
                icon: "icon-B-16-01",
                tags: ["MEDIA", "CINEMA", "MUSIC", "AUDIO"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-B-16-02",
                tags: ["MEDIA", "CINEMA", "MUSIC", "AUDIO"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-16-17",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "HEADPHONES"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-16-04",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "HEADPHONES"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-16-03",
                tags: ["MEDIA", "AV", "MUSIC", "SPEAKERS", "KARAOKE", "AUDIO", "MICROPHONE"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-16-05",
                tags: ["MEDIA", "AV", "MUSIC", "SPEAKERS", "KARAOKE", "AUDIO", "MICROPHONE"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-16-14",
                tags: ["MEDIA", "AV", "CINEMA", "MUSIC", "KARAOKE", "AUDIO", "SPEAKERS"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-16-15",
                tags: ["MEDIA", "AV", "CINEMA", "MUSIC", "KARAOKE", "AUDIO", "SPEAKERS"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-16-16",
                tags: ["MEDIA", "AV", "CINEMA", "MUSIC", "KARAOKE", "AUDIO", "SPEAKERS"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-g6",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-16-07",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-16-08",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-16-10",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-16-11",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-B-16-12",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 6
                }
            },
            {
                icon: "icon-B-16-13",
                tags: ["MEDIA", "CINEMA", "VIDEO", "TV"],
                position: {
                    row: 3,
                    column: 7
                }
            },
            {
                icon: "icon-B-16-18",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 8
                }
            },
            {
                icon: "icon-B-16-19",
                tags: ["MEDIA", "CINEMA", "VIDEO", "CAMERA", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 9
                }
            },
            {
                icon: "icon-B-17-05",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 10
                }
            },
            {
                icon: "icon-B-17-06",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 11
                }
            },
            {
                icon: "icon-B-17-07",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 12
                }
            },
            {
                icon: "icon-B-17-08",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 13
                }
            },
            {
                icon: "icon-B-17-09",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 14
                }
            },
            {
                icon: "icon-B-17-10",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "FILMING"],
                position: {
                    row: 3,
                    column: 15
                }
            },
            {
                icon: "icon-B-17-11",
                tags: ["MEDIA", "CINEMA", "VIDEO", "RECORD", "PROJECTOR", "TV"],
                position: {
                    row: 3,
                    column: 16
                }
            },
            {
                icon: "icon-B-17-03",
                tags: ["CINEMA", "FOOD"],
                position: {
                    row: 4,
                    column: 1
                }
            },

            {
                icon: "icon-B-17-04",
                tags: ["CINEMA", "DRINKS"],
                position: {
                    row: 4,
                    column: 2
                }
            },

            {
                icon: "icon-B-17-02",
                tags: ["CINEMA", "GLASSES"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-B-17-01",
                tags: ["MEDIA", "CINEMA", "CONFERENCE", "KARAOKE", "TV"],
                position: {
                    row: 4,
                    column: 4
                }
            },
            {
                icon: "icon-B-16-20",
                tags: ["MEDIA", "CINEMA", "CONFERENCE", "KARAOKE", "TV"],
                position: {
                    row: 4,
                    column: 5
                }
            },

            {
                icon: "icon-A-09-06",
                tags: ["MEDIA", "BLUETOOTH"],
                position: {
                    row: 5,
                    column: 1
                }
            },
            {
                icon: "icon-A-09-05",
                tags: ["MEDIA", "USB"],
                position: {
                    row: 5,
                    column: 2
                }
            },
            {
                icon: "icon-d-arrows6-media",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE", "ARROW"],
                series: ["alba"],
                position: {
                    row: 6,
                    column: 1
                }
            },
            {
                icon: "icon-d-plus5-sound",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 6,
                    column: 2
                }
            },
            {
                icon: "icon-d-plus5-sound-2v",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "PLUS", "MINUS", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 6,
                    column: 3
                }
            },
            {
                icon: "icon-d-icon6-media-forward",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 6,
                    column: 4
                }
            },
            {
                icon: "icon-d-icon7-media-next",
                tags: ["MEDIA", "AV", "MUSIC", "AUDIO", "DOUBLE"],
                series: ["alba"],
                position: {
                    row: 6,
                    column: 5
                }
            },
            {
                icon: "icon-h3",
                tags: ["INTERFACE", "MASTER ON/OFF", "CONTROL"],
                position: {
                    row: 7,
                    column: 1
                }
            },
            {
                icon: "icon-g2",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 7,
                    column: 2
                }
            },
            {
                icon: "icon-g3",
                tags: ["INTERFACE", "ARROW", "CONTROL"],
                position: {
                    row: 7,
                    column: 3
                }
            },
            {
                icon: "icon-g4",
                tags: ["INTERFACE", "ARROW", "UP", "CONTROL"],
                position: {
                    row: 7,
                    column: 4
                }
            },
            {
                icon: "icon-g5",
                tags: ["INTERFACE", "ARROW", "DOWN", "CONTROL"],
                position: {
                    row: 7,
                    column: 5
                }
            },
            {
                icon: "icon-f6",
                tags: ["INTERFACE", "MINUS", "CONTROL"],
                position: {
                    row: 7,
                    column: 6
                }
            },
            {
                icon: "icon-g7",
                tags: ["INTERFACE", "PLUS", "CONTROL"],
                position: {
                    row: 7,
                    column: 7
                }
            },
        ]
    },
    {
        label: 'Kitchen',
        value: 'KITCHEN',
        icon: 'icon-B-04-13',
        icons: [{
                icon: "icon-B-04-01",
                tags: ["KITCHEN", "APPLIANCE", "KETTLE"],
                position: {
                    row: 1,
                    column: 1
                }

            },
            {
                icon: "icon-B-04-13",
                tags: ["KITCHEN", "APPLIANCE", "KETTLE"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-04-02",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-04-04",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-04-03",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-04-05",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-04-06",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-04-07",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-04-08",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-04-09",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-04-10",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "COFE", "EAT"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-04-11",
                tags: ["KITCHEN", "APPLIANCE", "RESTAURANT", "COOKING", "EAT"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-B-04-12",
                tags: ["KITCHEN", "RESTAURANT", "EAT", "DINING", "FORK", "SPOON"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-B-04-14",
                tags: ["KITCHEN", "DRINKS", "RESTAURANT"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-B-04-15",
                tags: ["KITCHEN", "CANDLES", "RESTAURANT"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-B-04-16",
                tags: ["KITCHEN", "BAR"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-04-17",
                tags: ["KITCHEN", "KITCHEN ISLAND"],
                position: {
                    row: 1,
                    column: 17
                }
            },
        ]
    },
    {
        label: 'Bathroom',
        value: 'BATHROOM',
        icon: 'icon-B-05-12',
        icons: [{
                icon: "icon-B-05-10",
                tags: ["BATHROOM", "TOILET"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-05-11",
                tags: ["BATHROOM", "TOILET"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-05-12",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-05-13",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-05-14",
                tags: ["BATHROOM", "WASHBASIN", "SHOWER"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-05-15",
                tags: ["BATHROOM", "WASHBASIN", "SHOWER"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-05-16",
                tags: ["BATHROOM", "SHOWER"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-22-11",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-22-12",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-22-07",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-22-19",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "MUR", "BATHROOM"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-22-20",
                tags: ["HOTEL", "HOSPITALITY", "ROOM", "TOWEL", "BATHROOM"],
                position: {
                    row: 1,
                    column: 12
                }
            }, {
                icon: "icon-B-05-01",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-05-02",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-05-03",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-05-04",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-05-05",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-05-06",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-05-07",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-05-08",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-B-05-09",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 9
                }
            },
            {
                icon: "icon-B-05-17",
                tags: ["BATHROOM", "BEAUTY"],
                position: {
                    row: 2,
                    column: 10
                }
            },
            {
                icon: "icon-B-06-01",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-06-02",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-06-03",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-06-04",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-06-05",
                tags: ["BATHROOM", "TOILET", "WC"],
                position: {
                    row: 3,
                    column: 5
                }
            },
        ]
    },
    {
        label: 'Garden',
        value: 'GARDEN',
        icon: 'icon-B-11-10',
        icons: [{
                icon: "icon-B-11-13",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-11-10",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-11-11",
                tags: ["GARDEN", "OUTDOOR", "TREE", "GREEN"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-11-12",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-11-14",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-11-15",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-11-16",
                tags: ["GARDEN", "OUTDOOR", "FLOWER", "GREEN"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-11-17",
                tags: ["OUTDOOR", "GREEN", "RELAX", "SPA"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-11-18",
                tags: ["OUTDOOR", "GREEN", "MOUNTAINS"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-06-06",
                tags: ["ENVIRONMENT", "RECYCLING", "GREEN"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-06-07",
                tags: ["ENVIRONMENT", "TRASH", "BASCKET"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-23-06",
                tags: ["ENVIRONMENT", "RECYCLING", "GREEN"],
                position: {
                    row: 3,
                    column: 3
                }
            },
        ]
    },
    {
        label: 'Security',
        value: 'SECURITY',
        icon: 'icon-B-09-13',
        icons: [{
                icon: "icon-B-09-08",
                tags: ["SECURITY", "DOOR", "DOORLOCK"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-09-13",
                tags: ["SECURITY", "DOORLOCK", "LOCK"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-09-14",
                tags: ["SECURITY", "DOORLOCK", "LOCK", "UNLOCK"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-09-15",
                tags: ["SECURITY"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-09-16",
                tags: ["SECURITY"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-09-17",
                tags: ["SECURITY", "DOORLOCK", "LOCK", "KEYPAD"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-09-18",
                tags: ["SECURITY", "IMPRINT", "LOCK", "UNLOCK"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-09-01",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-09-02",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-09-03",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-09-04",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-09-05",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 12
                }

            },
            {
                icon: "icon-B-09-06",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 13
                }

            },
            {
                icon: "icon-B-09-07",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-B-09-11",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-c4",
                tags: ["DOORLOCK", "RFID", "KEY"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-21-01",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-21-07",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-21-08",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-21-09",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-21-10",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-21-11",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-21-12",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 7
                }
            },
            {
                icon: "icon-B-21-13",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 8
                }
            },
            {
                icon: "icon-B-21-14",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 9
                }
            },
            {
                icon: "icon-B-21-15",
                tags: ["SECURITY", "CCTV", "CAMERA"],
                position: {
                    row: 2,
                    column: 10
                }
            },
            {
                icon: "icon-B-09-09",
                tags: ["SECURITY", "ALARM", "BELL"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-09-10",
                tags: ["SECURITY", "ALARM", "BELL"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-09-12",
                tags: ["SECURITY", "ALARM", "BELL", "SOS"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-21-02",
                tags: ["SECURITY", "ALARM"],
                position: {
                    row: 3,
                    column: 4
                }
            },
        ]
    },
    {
        label: 'Office',
        value: 'OFFICE',
        icon: 'icon-B-10-01',
        icons: [{
                icon: "icon-B-10-01",
                tags: ["OFFICE", "IT", "NETWORK", "COMPUTER", "LAPTOP"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-10-02",
                tags: ["OFFICE", "IT", "PRINTER", "NETWORK"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-10-03",
                tags: ["OFFICE", "IT", "CAMERA", "NETWORK"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-10-04",
                tags: ["OFFICE", "IT", "MONITOR", "NETWORK", "COMPUTER"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-10-05",
                tags: ["OFFICE", "IT", "PHONE", "NETWORK"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-10-06",
                tags: ["OFFICE", "IT", "NETWORK", "GAME"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-10-07",
                tags: ["OFFICE", "IT", "NETWORK", "COMPUTER", "MONITOR"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-10-11",
                tags: ["OFFICE", "IT", "NETWORK"],
                position: {
                    row: 1,
                    column: 8
                }
            },
        ]
    },
    {
        label: 'Accessories',
        value: 'ACCESSORIES',
        icon: 'icon-B-15-06',
        icons: [{
                icon: "icon-B-10-08",
                tags: ["ACCESSORIES", "TIME", "CLOCK", "DISPLAY", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-10-09",
                tags: ["ACCESSORIES", "TIME", "CLOCK", "DISPLAY", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-10-10",
                tags: ["ACCESSORIES", "FURNITURE"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-15-06",
                tags: ["ACCESSORIES", "DECORATION", "VASE", "FURNITURE"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-15-07",
                tags: ["ACCESSORIES", "MIRROR", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-15-08",
                tags: ["ACCESSORIES", "MIRROR", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-15-09",
                tags: ["ACCESSORIES", "DECORATION", "FURNITURE"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-15-10",
                tags: ["ACCESSORIES", "DECORATION", "VASE", "FURNITURE"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-15-11",
                tags: ["ACCESSORIES", "DECORATION", "CARPET", "FURNITURE"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-15-17",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 1
                }
            },
            {
                icon: "icon-B-24-01",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 2
                }
            },
            {
                icon: "icon-B-24-02",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 3
                }
            },
            {
                icon: "icon-B-24-03",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 4
                }
            },
            {
                icon: "icon-B-24-04",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 5
                }
            },
            {
                icon: "icon-B-24-05",
                tags: ["SCENE", "BOOK", "READING", "MOOD"],
                position: {
                    row: 2,
                    column: 6
                }
            },
            {
                icon: "icon-B-29-01",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 1
                }
            },
            {
                icon: "icon-B-29-02",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 2
                }
            },
            {
                icon: "icon-B-29-03",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 3
                }
            },
            {
                icon: "icon-B-29-04",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 4
                }
            },
            {
                icon: "icon-B-29-05",
                tags: ["ACCESSORIES", "STAIRCASE"],
                position: {
                    row: 3,
                    column: 5
                }
            },
            {
                icon: "icon-B-06-08",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 1
                }
            },
            {
                icon: "icon-B-06-09",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 2
                }
            },
            {
                icon: "icon-B-06-10",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 3
                }
            },
            {
                icon: "icon-B-06-11",
                tags: ["ACCESSORIES", "CIGAR"],
                position: {
                    row: 4,
                    column: 4
                }
            },
        ]
    },
    {
        label: 'Fireplace',
        value: 'FIREPLACE',
        icon: 'icon-B-11-04',
        icons: [{
                icon: "icon-B-11-01",
                tags: ["FIREPLACE", "STOVE", "FIRE", "WOOD"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-11-02",
                tags: ["FIREPLACE", "STOVE", "FIRE", "WOOD"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-11-03",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-11-04",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-11-05",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-11-06",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-11-07",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-11-08",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-11-09",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-11-19",
                tags: ["FIREPLACE", "STOVE", "FIRE"],
                position: {
                    row: 1,
                    column: 10
                }
            },
        ]
    },
    {
        label: 'Garage',
        value: 'GARAGE',
        icon: 'icon-B-12-06',
        icons: [{
                icon: "icon-B-12-01",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-12-02",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-12-03",
                tags: ["GARAGE", "CAR"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-12-04",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-12-05",
                tags: ["GARAGE"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-12-06",
                tags: ["GARAGE", "CAR"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-12-07",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-12-08",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-12-09",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-12-10",
                tags: ["CAR"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-12-11",
                tags: ["TRAFFIC LIGHTS"],
                position: {
                    row: 1,
                    column: 11
                }
            },
        ]
    },
    {
        label: 'Clima',
        value: 'CLIMA',
        icon: 'icon-B-13-17',
        icons: [{
                icon: "icon-B-19-03",
                tags: ["CLIMA", "TECHNICAL", "FURNACE"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-19-04",
                tags: ["CLIMA", "TECHNICAL", "PUMP"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-19-05",
                tags: ["CLIMA", "TECHNICAL", "PUMP"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-19-06",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-19-07",
                tags: ["CLIMA", "TECHNICAL", "FLOORHEATING"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-19-08",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "FURNACE"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-19-09",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "FURNACE"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-19-10",
                tags: ["CLIMA", "TECHNICAL", "MACHINE", "BOILER", "FURNACE"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-19-11",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-19-12",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-19-13",
                tags: ["CLIMA", "TECHNICAL", "FLOORHEATING"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-19-14",
                tags: ["CLIMA", "TECHNICAL", "CONTROL", "KEYPAD"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-B-19-15",
                tags: ["CLIMA", "TECHNICAL"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-B-21-03",
                tags: ["CLIMA", "TECHNICAL", "SIGNS"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-B-21-04",
                tags: ["CLIMA", "TECHNICAL", "SIGNS"],
                position: {
                    row: 1,
                    column: 15
                }
            },
        ]
    },
    {
        label: 'Relax',
        value: 'SPA',
        icon: 'icon-B-14-01',
        icons: [{
                icon: "icon-B-14-01",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-14-02",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-14-03",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-14-04",
                tags: ["SPA", "SAUNA", "RELAX", "SWIMING"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-14-05",
                tags: ["SPA", "SAUNA", "RELAX"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-14-06",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-14-07",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-14-08",
                tags: ["SPA", "RELAX"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-14-09",
                tags: ["SPA", "SAUNA", "RELAX", "POOL"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-14-10",
                tags: ["SPA", "RELAX", "MASSAGE"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-14-11",
                tags: ["RELAX", "TENNIS", "GYM"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-14-12",
                tags: ["RELAX", "GYM"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-B-15-15",
                tags: ["SPA", "SAUNA", "RELAX", "CANDLES"],
                position: {
                    row: 1,
                    column: 13
                }
            },
            {
                icon: "icon-B-11-17",
                tags: ["OUTDOOR", "GREEN", "RELAX", "SPA"],
                position: {
                    row: 1,
                    column: 14
                }
            },
            {
                icon: "icon-B-14-13",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 15
                }
            },
            {
                icon: "icon-B-14-14",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 16
                }
            },
            {
                icon: "icon-B-14-15",
                tags: ["YOGA", "RELAX", "MEDITATION"],
                position: {
                    row: 1,
                    column: 17
                }
            },
            {
                icon: "icon-B-14-16",
                tags: ["CARDIO", "GYM", "RELAX"],
                position: {
                    row: 1,
                    column: 18
                }
            },
            {
                icon: "icon-B-14-17",
                tags: ["CARDIO", "GYM", "RELAX"],
                position: {
                    row: 1,
                    column: 19
                }
            },
            {
                icon: "icon-B-14-18",
                tags: ["SPA", "PATIO", "RELAX"],
                position: {
                    row: 1,
                    column: 20
                }
            },
            {
                icon: "icon-B-14-19",
                tags: ["SPA", "PATIO", "RELAX"],
                position: {
                    row: 1,
                    column: 21
                }
            },
            {
                icon: "icon-B-14-20",
                tags: ["GOLF", "RELAX", "GYM"],
                position: {
                    row: 1,
                    column: 22
                }
            },
        ]
    },
    {
        label: 'Pet',
        value: 'KID',
        icon: 'icon-B-15-02',
        icons: [{
                icon: "icon-B-15-01",
                tags: ["KID", "TOY"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-15-02",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-15-03",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-15-04",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-15-05",
                tags: ["KID", "PET"],
                position: {
                    row: 1,
                    column: 5
                }
            },
        ]
    },
    {
        label: 'Power',
        value: 'BATTERY',
        icon: 'icon-B-18-09',
        icons: [{
                icon: "icon-B-18-01",
                tags: ["POWER"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-18-02",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-18-03",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-18-04",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-18-05",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-18-06",
                tags: ["BATTERY", "POWER", "GENERATOR"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-18-07",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-18-08",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-18-09",
                tags: ["BATTERY", "POWER"],
                position: {
                    row: 1,
                    column: 9
                }
            },
        ]
    },
    {
        label: 'Sockets',
        value: 'SOCKETS',
        icon: 'icon-B-20-01',
        icons: [{
                icon: "icon-B-20-01",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-20-02",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-20-03",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-20-04",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-20-05",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-20-06",
                tags: ["SOCKETS"],
                position: {
                    row: 1,
                    column: 6
                }
            },
        ]
    },
    {
        label: 'Slider',
        value: 'SLIDER',
        icon: 'icon-slider_5',
        icons: [{
                icon: "icon-slider_1",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-slider_2",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-slider_3",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-slider_4",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-slider_5",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-slider_61",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-slider_62",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-slider_63",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-slider_64",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-slider_7",
                tags: ["SLIDER"],
                series: ["aria|L12"],
                position: {
                    row: 1,
                    column: 10
                }
            },
        ]
    },
    {
        label: 'Delivery',
        value: 'DELIVERY',
        icon: 'icon-B-28-04',
        icons: [{
                icon: "icon-B-28-01",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-28-02",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-28-03",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-28-04",
                tags: ["DELIVERY"],
                position: {
                    row: 1,
                    column: 4
                }
            },

        ]
    },
    {
        label: 'Outdoor Heater',
        value: 'OUTDOOR HEATER',
        icon: 'icon-B-27-09',
        icons: [{
                icon: "icon-B-27-01",
                tags: ["OUTDOOR", "HEATER"],
                position: {
                    row: 1,
                    column: 1
                }
            },
            {
                icon: "icon-B-27-02",
                tags: ["OUTDOOR", "SOLAR PANEL"],
                position: {
                    row: 1,
                    column: 2
                }
            },
            {
                icon: "icon-B-27-03",
                tags: ["OUTDOOR", "HEATER"],
                position: {
                    row: 1,
                    column: 3
                }
            },
            {
                icon: "icon-B-27-04",
                tags: ["OUTDOOR", "CARBON"],
                position: {
                    row: 1,
                    column: 4
                }
            },
            {
                icon: "icon-B-27-05",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 5
                }
            },
            {
                icon: "icon-B-27-06",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 6
                }
            },
            {
                icon: "icon-B-27-07",
                tags: ["OUTDOOR", "HEATER", "RADIATOR"],
                position: {
                    row: 1,
                    column: 7
                }
            },
            {
                icon: "icon-B-27-08",
                tags: ["OUTDOOR", "HEATER"],
                position: {
                    row: 1,
                    column: 8
                }
            },
            {
                icon: "icon-B-27-09",
                tags: ["OUTDOOR", "HEATER", "FIREPLACE"],
                position: {
                    row: 1,
                    column: 9
                }
            },
            {
                icon: "icon-B-27-10",
                tags: ["OUTDOOR", "BBQ"],
                position: {
                    row: 1,
                    column: 10
                }
            },
            {
                icon: "icon-B-27-11",
                tags: ["OUTDOOR", "BBQ"],
                position: {
                    row: 1,
                    column: 11
                }
            },
            {
                icon: "icon-B-27-12",
                tags: ["OUTDOOR", "FIRE TORCH", "TEMPEST TORCH"],
                position: {
                    row: 1,
                    column: 12
                }
            },
            {
                icon: "icon-B-27-13",
                tags: ["OUTDOOR", "HEATER", "LIGHT"],
                position: {
                    row: 1,
                    column: 13
                }
            },
        ]
    },

]